import React, { PureComponent } from 'react'
import BlockCard from './BlockCard'

interface Props {
  cover: string
  type?: 'small' | 'middle'
  dataType?: string
  title?: string
  className?: string
  style?: React.CSSProperties
  bodyStyle?: React.CSSProperties
  nometa?: boolean
  watch?: number
  time?: number
  collect?: any
  onClick?: () => any
  loading?: boolean
  course?: boolean
  durl?: string
  id?: number
}

class Card extends PureComponent<Props> {
  static defaultProps = {
    type: 'small',
  }

  render() {
    const { type, watch, onClick, className, style, ...rest } = this.props
    const component = <BlockCard type={type} watch={watch} {...rest} />
    return (
      <div onClick={onClick} className={className} style={style}>
        {component}
      </div>
    )
  }
}

export default Card
